import { Navigate, useParams } from 'react-router-dom';

import { useGetEntidadFinanciera } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveEntidadesFinancieras } from '../../shared/saveEntidadesFinancieras';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export interface UpdateEntidadesFinancierasPageInterface {}

const UpdateEntidadesFinancierasPage: React.FC<UpdateEntidadesFinancierasPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_entidadfinanciera)
  const { id } = useParams();
  const { data, isLoading } = useGetEntidadFinanciera(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_entidad_financiera) return <Navigate to="/parametrizacion/entidades-financieras" />;

  return <SaveEntidadesFinancieras titlePage="Editar Entidad financiera" editEntidadesFinancieras={data.data} />;
};

export default UpdateEntidadesFinancierasPage;
